var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as api from '@codegrade/api';
import client from '@/client';
import { immutable } from '@/utils';
let TenantPrice = class TenantPrice extends api.TenantPrice {
};
TenantPrice = __decorate([
    immutable
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], TenantPrice);
export { TenantPrice };
let CoursePrice = class CoursePrice extends api.CoursePrice {
    /**
     * Starts the payment process.
     *
     * @param next The location that the user should be redirected to after the
     * transaction has been processed.
     * @param newTab Whether to use a new tab for the payment service.
     * @returns The result of the api call to begin the payment process.
     */
    startPayment(next, newTab) {
        return client.coursePrice.startPayment({
            priceId: this.id,
            requestBody: {
                mode: newTab ? 'close_tab' : 'redirect',
                nextRoute: next,
            },
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    payWithCoupon(couponCode) {
        return client.coursePrice.payWithCoupon({
            priceId: this.id,
            requestBody: {
                code: couponCode,
            },
        });
    }
};
CoursePrice = __decorate([
    immutable
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], CoursePrice);
export { CoursePrice };
